import { Injectable } from '@angular/core';
import { AppClientConfigurationService } from '@sdbn/common';
import { LayoutDefinition } from './transport-details-model';

@Injectable({
  providedIn: 'root'
})
export class TransportDetailsLayoutService {

  constructor(
    private configurationService: AppClientConfigurationService
  ) { }

  public createRegistrationTerminalMasterdataLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.registration-terminal.masterdata.layout';
    let layoutDefinition = this.readLayout(propertyKey);

    if (layoutDefinition == null) {

      const defaultModel = {
        sections: [
          {
            fields: [
              { key: 'carrier', required: true, identifier: 'transport_details_field_carrier_0' },
              { key: 'supplier', identifier: 'transport_details_field_supplier_1' },
              { key: 'driver', required: true, identifier: 'transport_details_field_driver_2' },
              { key: 'co-driver', identifier: 'transport_details_field_co-driver_3' },
              { key: 'numberplate', required: true, identifier: 'transport_details_field_numberplate_4' },
              { key: 'trailer-number-plate', identifier: 'transport_details_field_trailer-number-plate_5' },
              { key: 'order-reference', identifier: 'transport_details_field_order-reference_6' },
            ]
          }
        ]
      };
      layoutDefinition = new LayoutDefinition(defaultModel);

      console.log('Using default layout for [' + propertyKey + ']', JSON.stringify(defaultModel));
    }

    return layoutDefinition;
  }


  public createRegisterTransportMasterdataLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.register-transport.masterdata.layout';

    let layoutDefinition = this.readLayout(propertyKey);

    if (layoutDefinition == null) {

      const defaultModel = {
        sections: [
          {
            fields: [
              { key: 'carrier', required: true, identifier: 'transport_details_field_carrier_0' },
              { key: 'supplier', required: true, identifier: 'transport_details_field_supplier_1' },
              { key: 'driver', required: true, identifier: 'transport_details_field_driver_2' },
              { key: 'co-driver', identifier: 'transport_details_field_co-driver_3' },
              { key: 'numberplate', identifier: 'transport_details_field_numberplate_4' },
              { key: 'trailer-number-plate', identifier: 'transport_details_field_trailer-number-plate_5' },
              { key: 'swap-trailer-number', identifier: 'transport_details_field_swap-trailer-number_6' },
            ]
          }, {
            fields: [
              { key: 'order-reference', identifier: 'transport_details_field_order-reference_7' },
              { key: 'string1', identifier: 'transport_details_field_string-1_8' },
              { key: 'string2', identifier: 'transport_details_field_string-2_9' },
              { key: 'phone', identifier: 'transport_details_field_phone_10' },
              { key: 'identity-card', identifier: 'transport_details_field_identity-card_11' },
              { key: 'data-protection-rule', identifier: 'transport_details_field_data-protection-rule_12' }
            ]
          }, {
            fields: [
              { key: 'urgent', identifier: 'transport_details_field_urgent_13' },
              { key: 'important', identifier: 'transport_details_field_important_14' },
              { key: 'dangerous-goods', identifier: 'transport_details_field_dangerous-goods_15' },
              { key: 'delayed-leave', identifier: 'transport_details_field_delayed-leave_16' },
              { key: 'pickup-truck', identifier: 'transport_details_field_pickup-truck_17' },
              { key: 'intermitted', identifier: 'transport_details_field_intermitted_18' },
              { key: 'preloading', identifier: 'transport_details_field_preloading_19' },
              { key: 'planning-type', identifier: 'transport_details_field_planning-type_20' },
              { key: 'register-now', identifier: 'transport_details_field_register-now_21' }
            ]
          }
        ]
      };
      layoutDefinition = new LayoutDefinition(defaultModel);

      console.log('Using default layout for [' + propertyKey + ']', JSON.stringify(defaultModel));
    }

    return layoutDefinition;
  }

  public createEditTransportMasterdataLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.edit-transport.masterdata.layout';

    let layoutDefinition = this.readLayout(propertyKey);

    if (layoutDefinition == null) {

      const defaultModel = {
        sections: [
          {
            fields: [
              { key: 'carrier', required: true, identifier: 'transport_details_field_carrier_0' },
              { key: 'supplier', identifier: 'transport_details_field_supplier_1' },
              { key: 'driver', identifier: 'transport_details_field_driver_2' },
              { key: 'co-driver', identifier: 'transport_details_field_co-driver_3' },
              { key: 'numberplate', identifier: 'transport_details_field_numberplate_4' },
              { key: 'trailer-number-plate', identifier: 'transport_details_field_trailer-number-plate_5' },
              { key: 'swap-trailer-number', identifier: 'transport_details_field_swap-trailer-number_6' },
            ]
          }, {
            fields: [
              { key: 'order-reference', identifier: 'transport_details_field_order-reference_7' },
              { key: 'string1', identifier: 'transport_details_field_string-1_8' },
              { key: 'string2', identifier: 'transport_details_field_string-2_9' },
              { key: 'phone', identifier: 'transport_details_field_phone_10' },
              { key: 'identity-card', identifier: 'transport_details_field_identitiy-card_11' },
              { key: 'data-protection-rule', identifier: 'transport_details_field_data-protection-rule_12' }
            ]
          }, {
            fields: [
              { key: 'urgent', identifier: 'transport_details_field_urgent_13' },
              { key: 'important', identifier: 'transport_details_field_important_14' },
              { key: 'dangerous-goods', identifier: 'transport_details_field_dangerous-goods_15' },
              { key: 'delayed-leave', identifier: 'transport_details_field_delayed-leave_16' },
              { key: 'pickup-truck', identifier: 'transport_details_field_pickup-truck_17' },
              { key: 'useGlobalConnect', required: true, identifier: 'transport_details_field_useGlobalConnect_18' },
              { key: 'messaging-language', required: true, identifier: 'transport_details_field_messaging-language_19' },
              { key: 'intermitted', identifier: 'transport_details_field_intermitted_20' },
              { key: 'preloading', identifier: 'transport_details_field_preloading_21' },
              { key: 'planning-type', identifier: 'transport_details_field_planning-type_22' },
              { key: 'register-now', identifier: 'transport_details_field_register-now_23' }
            ]
          }
        ]
      };
      layoutDefinition = new LayoutDefinition(defaultModel);

      console.log('Using default layout for [' + propertyKey + ']', JSON.stringify(defaultModel));
    }

    return layoutDefinition;
  }

  public createEntranceReadonlyDefaultLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.entrance.readOnly-default.layout';
    return this.readLayout(propertyKey);

  }

  public createEntranceReadonlyMobileLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.entrance.readOnly-mobile.layout';
    return this.readLayout(propertyKey);

  }

  public createEntranceEditingDefaultLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.entrance.editing-default.layout';
    return this.readLayout(propertyKey);

  }

  public createEntranceEditingMobileLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.entrance.editing-mobile.layout';
    return this.readLayout(propertyKey);

  }

  public createStationAssignmentTransportDetailsGridLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.station-assignment.transport-details-grid.layout';

    let layoutDefinition = this.readLayout(propertyKey);

    if (layoutDefinition == null) {

      const defaultModel = {
        sections: [
          {
            fields: [
              { key: 'identifier', identifier: 'transport_details_field_identifier_0' },
              { key: 'carrier', identifier: 'transport_details_field_carrier_1' },
              { key: 'cargo', identifier: 'transport_details_field_cargo_2' },
              { key: 'order-reference', identifier: 'transport_details_field_order-reference_3' },
              { key: 'string2', identifier: 'transport_details_field_string-2_4' },
              { key: 'transport-option-marks', identifier: 'transport_details_field_transport-option-marks_5' },
              { key: 'current-routing-position-hint', identifier: 'transport_details_field_current-routing-position-hint_6' },
              { key: 'current-routing-position-cargo', identifier: 'transport_details_field_current-routing-position-cargo_7' },
              { key: 'current-routing-position-name', identifier: 'transport_details_field_current-routing-position-name_8' },
              { key: 'entrance-date', identifier: 'transport_details_field_entrance-date_9' },
              { key: 'planning-date', identifier: 'transport_details_field_planning-date_10' },
              { key: 'waiting-time', identifier: 'transport_details_field_waiting-time_11' },
              { key: 'processing-time', identifier: 'transport_details_field_processing-time_12' },
            ]
          }
        ]
      };
      layoutDefinition = new LayoutDefinition(defaultModel);
      console.log('Using default layout for [' + propertyKey + ']', JSON.stringify(defaultModel));
    }

    return layoutDefinition;
  }


  public createStationAssignmentStationDetailsGridLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.station-assignment.station-details-grid.layout';

    let layoutDefinition = this.readLayout(propertyKey);

    if (layoutDefinition == null) {

      const defaultModel = {
        sections: [
          {
            fields: [
              { key: 'identifier', identifier: 'transport_details_field_identifier_0' },
              { key: 'carrier', identifier: 'transport_details_field_carrier_1' },
              { key: 'current-routing-position-cargo', identifier: 'transport_details_field_current-routing-position-cargo_2' },
              { key: 'current-routing-position-hint', identifier: 'transport_details_field_current-routing-position-hint_3' },
              { key: 'string2', identifier: 'transport_details_field_string-2_4' },
            ]
          },
          {
            fields: [
              { key: 'transport-option-marks', identifier: 'transport_details_field_transport-option-marks_5' },
              { key: 'entrance-date', identifier: 'transport_details_field_entrance-date_6' },
              { key: 'waiting-time', identifier: 'transport_details_field_waiting-time_7' },
              { key: 'processing-time', identifier: 'transport_details_field_processing-time_8' },
            ]
          }
        ]
      };
      layoutDefinition = new LayoutDefinition(defaultModel);
      console.log('Using default layout for [' + propertyKey + ']', JSON.stringify(defaultModel));
    }

    return layoutDefinition;
  }

  public createActionTabeletTransportDetailsGridLayout(): LayoutDefinition {

    const propertyKey = 'ui-component.action-tablet.transport-details.layout';

    let layoutDefinition = this.readLayout(propertyKey);

    if (layoutDefinition == null) {

      const defaultModel = {
        sections: [
          {
            fields: [
              { key: 'identifier', identifier: 'transport_details_field_identifier_0' },
              { key: 'carrier', identifier: 'transport_details_field_carrier_1' },
              { key: 'current-routing-position-cargo', identifier: 'transport_details_field_current-routing-position-cargo_2' },
              { key: 'current-routing-position-hint', identifier: 'transport_details_field_current-routing-position-hint_3' },
              { key: 'string2', identifier: 'transport_details_field_string-2_4' },
            ]
          },
          {
            fields: [
              { key: 'transport-option-marks', identifier: 'transport_details_field_transport-option-marks_5' },
              { key: 'entrance-date', identifier: 'transport_details_field_entrance-date_6' },
              { key: 'waiting-time', identifier: 'transport_details_field_waiting-time_7' },
              { key: 'processing-time', identifier: 'transport_details_field_processing-time_8' },
            ]
          }
        ]
      };
      layoutDefinition = new LayoutDefinition(defaultModel);
      console.log('Using default layout for [' + propertyKey + ']', JSON.stringify(defaultModel));
    }
    return layoutDefinition;
  }

  private readLayout(propertyKey: string): LayoutDefinition {
    const param = this.configurationService.getProperty(propertyKey);

    if (param != null && param.value != null && param.value.length > 0) {
      try {
        const layout = new LayoutDefinition(JSON.parse(param.value));
        layout.dictionaryBase = 'dd.PROPERTY';
        // TODO im neuen Ansatz gibt es keine ID mehr, Lösung offen
        // layout.propertyId = param.id;
        return layout;
      } catch (error) {
        console.error('Error while reading layout form config [' + propertyKey + '].');
        return null;
      }
    }
  }
}
